import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import {
  Grid,
  Button,
} from '../../canvasComponents/index';
// icons
import submittedIcon from '../../img/status/SubmittedStatus.svg';
import infoAdjuster from '../../img/global/information.svg';
import processingIcon from '../../img/status/processingStatus.svg';
// messages
import messages from './messages';
// constants
import { GET_CLAIM_STATUS, GET_CLAIM_STATUS_FR } from '../../utils/constants/claimStatusTypes';
import { getClaimType } from '../../utils/claim/getClaimType';

/**
 *
 *
 * Component returns 2 types of Claim Tiles
 *  1.) No Claims found.
 *  2.) Not implemented : Claim status is in Progress and Active (Data returns from BFF)
 *  3.) Claim status is submitted || assisted  and InActive (Data returns from GW)
 *
 *  Note : InActive condition referes to no more action can be taken on Claim &
 *  Active Only claim can go to /claim/:claimId
 */
function ClaimTile(props) {
  const { noFoundClaims, isActive, formattedDate, handleOnClickAdjuster,
    vehicleModel, propertyAddress, gwClaimStatus, gwClaimId, gwCdsClaimNumber,
    gwClaimNumber, claimLossScenarioLevel1, adjusterDetails, language } = props;

  const setClaimStatus = () => {
    let icon = null;
    switch (gwClaimStatus) {
      case GET_CLAIM_STATUS.Submitted:
      case GET_CLAIM_STATUS_FR.Submitted:
        icon = submittedIcon;
        break;
      case GET_CLAIM_STATUS.Processing:
      case GET_CLAIM_STATUS_FR.Processing:
        icon = processingIcon;
        break;
      default:
        icon = infoAdjuster;
        break;
    }
    return (
      <span className="submittedStatus">
        <img alt="" src={icon} className="status-icon status-icon--left" />
        <FormattedMessage
          {...messages.gwClaimStatus}
          values={{ gwClaimStatus }}
        />
      </span>
    );
  };

  if (noFoundClaims) {
    return (
      <div className="claim-divider">
        <Grid>
          <Grid.Row>
            <Grid.Column colSm12>
              <p className="no-claims-text">
                <FormattedMessage {...messages.noClaims} />
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  if (!noFoundClaims && !isActive) {
    return (
      <div key={gwClaimId} className="claim-divider">
        {/* First Row */}
        <Grid>
          <Grid.Row>
            <div className="claim-row">
              <Grid.Column colSm6>
                <span className="claim-title">
                  <h2 className="h2title">
                    <div className="claim-number">
                      <span className="claimNumberText">
                        <FormattedMessage
                          {...messages.claimNumberText}
                          values={{ claimId: gwCdsClaimNumber || gwClaimNumber }}
                        />
                      </span>
                      <span className="claimNumberNoText">
                        { gwCdsClaimNumber || gwClaimNumber }
                      </span>
                    </div>
                  </h2>
                </span>
              </Grid.Column>
              <Grid.Column colSm6>
                <div className="textOnTheRight">
                  {/* STATUS */}
                  {setClaimStatus()}
                </div>
              </Grid.Column>
            </div>
          </Grid.Row>
          {/* Second Row - BOLD LABELS */}
          <Grid.Row>
            <Grid.Column colSm4>
              { vehicleModel && (
              <span className="claim-detail-subtitle">
                <FormattedMessage {...messages.vehicle} />
              </span>
              )}
              { propertyAddress && (
              <span className="claim-detail-subtitle">
                <FormattedMessage {...messages.property} />
              </span>
              )}
            </Grid.Column>
            <Grid.Column colSm4>
              <span className="claim-detail-subtitle">
                <FormattedMessage {...messages.claimType} />
              </span>
            </Grid.Column>
            <Grid.Column colSm4>
              <span className="claim-detail-subtitle">
                <FormattedMessage {...messages.incidentDate} />
              </span>
            </Grid.Column>
          </Grid.Row>
          {/* Third Row */}
          <Grid.Row>
            <Grid.Column colSm4>
              <span className="claim-detail-answer">
                {/* VEHICLE MODEL / PROPERTY ADDRESS */}
                { vehicleModel && (
                <FormattedMessage
                  {...messages.vehicleModel}
                  values={{
                    vehicleModel,
                  }}
                />
                )}
                {propertyAddress && (
                  <FormattedMessage
                    {...messages.propertyAddress}
                    values={{
                      propertyAddress,
                    }}
                  />
                )}

              </span>
            </Grid.Column>
            <Grid.Column colSm4>
              <span className="claim-detail-answer">
                {/* CLAIM TYPE */}
                { vehicleModel && (
                  <FormattedMessage
                    {...messages.claimTypeDescriptionLossScenario1}
                    values={{ lossScenario1: getClaimType(language, claimLossScenarioLevel1, 'auto') }}
                  />
                )}
                { propertyAddress && (
                  <FormattedMessage
                    {...messages.claimTypeDescriptionLossScenario1}
                    values={{ lossScenario1: getClaimType(language, claimLossScenarioLevel1, 'property') }}
                  />
                )}
              </span>
            </Grid.Column>
            <Grid.Column colSm4 className="date-adjuster-details-container">
              <span className="claim-detail-answer">
                {/* INCIDENT DATE */}
                <FormattedMessage
                  {...messages.dateOfIncident}
                  values={{
                    formattedDate,
                  }}
                />
              </span>
              <div className="claim-row adjuster-details">
                <Grid.Column colSm12>
                  <div className="textOnTheRight">
                    {/* ADJUSTER DETAILS */}
                    { adjusterDetails?.oracleId && adjusterDetails.oracleId !== 'DIGITAL' && (gwClaimStatus === GET_CLAIM_STATUS.Submitted || gwClaimStatus === GET_CLAIM_STATUS_FR.Submitted) && (
                    <Button
                      className="adjDetails"
                      onClick={() => handleOnClickAdjuster()}
                    ><FormattedMessage {...messages.adjusterDetails} />
                      <img alt="infoAdj" src={infoAdjuster} className="status-icon status-icon--right" />
                    </Button>
                    )}
                  </div>
                </Grid.Column>
              </div>
            </Grid.Column>

          </Grid.Row>
          {/* Fourth Row */}

        </Grid>
      </div>
    );
  }
}
export default injectIntl(ClaimTile);
